<template>
    <Popup position="bottom" style="height:50%;" v-model="panel" @click-overlay="timePopup(false)">
        <DatetimePicker
                v-if="type=='start'"
                v-model="dateTime"
                :max-date="maxDate"
                @confirm="timeOk"
                @cancel="timePopup(false)"
        />
        <DatetimePicker
                v-else-if="type=='end'"
                v-model="dateTime"
                :max-date="maxDate"
                :min-date="minDate"
                @confirm="timeOk"
                @cancel="timePopup(false)"
        />
        <DatetimePicker v-else v-model="dateTime" @confirm="timeOk" @cancel="timePopup(false)"/>
    </Popup>
</template>

<script>
    import {DatetimePicker, Popup} from "vant";
    import {dateFormat} from "@/utils/tool";

    export default {
        components: {
            Popup,
            DatetimePicker
        },
        props: {
            type: {type: String, required: false},
            time: {type: String, required: true},
            format: {type: String, default: "YYYY-MM-DD HH:mm:ss"},
            timePanel: {type: Boolean, required: true},
            min: {type: String, required: false},
            max: {type: String, required: false}
        },
        data() {
            return {
                panel: false,
                dateTime: new Date(),
                minDate: new Date(),
                maxDate: new Date()
            };
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            timePopup(show, e) {
                this.$emit("cancel");
            },
            timeOk(value) {
                this.$emit("ok", dateFormat(this.format, value));
            }
        },
        watch: {
            timePanel(value) {
                this.panel = value;
            },
            time(value) {
                if (window.__wxjs_is_wkwebview) {
                    value = value.replace(/-/g, "/");
                }
                this.dateTime = new Date(value);
            },
            min(value) {
                if (window.__wxjs_is_wkwebview) {
                    value = value.replace(/-/g, "/");
                }
                this.minDate = new Date(value);
            },
            max(value) {
                if (window.__wxjs_is_wkwebview) {
                    value = value.replace(/-/g, "/");
                }
                this.maxDate = new Date(value);
            }
        }
    };
</script>
